<h2 mat-dialog-title>{{ isNew ? "New Field Group" : "Edit Field Group" }}</h2>
<div mat-dialog-content>
  <div class="row">
    <div class="col-md-8"><mat-form-field class="full-width"><mat-label>Name</mat-label><input matInput [(ngModel)]="result.name" name="fgn" placeholder="e.g. Compensation" /></mat-form-field></div>
    <div class="col-md-4"><mat-form-field class="full-width"><mat-label>Sort order</mat-label><input matInput type="number" [(ngModel)]="result.sortOrder" name="fgso" /></mat-form-field></div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onSave()">Save field group</button>&nbsp;
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>&nbsp;
  <button mat-raised-button class="piButton" *ngIf="!isNew" (click)="onDelete()">Delete</button>
</div>
